import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { UserProvider } from "../user/user";
import { map } from "rxjs/operators";
import { Meeting } from "src/app/interfaces/meeting.interface";

@Injectable({ providedIn: "root" })
export class GrupoProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  constructor(public http: HttpClient, public userProvider: UserProvider) {}

  frequenciaParticipante(idGrupo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/frequencia-participante", {
        idGrupo: idGrupo,
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getTipoOcorrencia() {
    return this.http.get<any>(this.baseUrl + "/grupo/get-tipo-ocorrencias").pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  solicitacaoDesligamento(idGrupo: any, idParticipante: any, tipo: any, tipoGrupo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/solicitacao-desligamento", {
        idGrupo: idGrupo,
        idParticipante: idParticipante,
        tipo: tipo,
        tipoGrupo: tipoGrupo,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  buscarTodosGrupos(filtro: any, pag: { currentPage: any }, idGrupo: any, tipo: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/buscar-todos-grupos", {
        observe: "response",
        params: {
          page: pag.currentPage,
          "per-page": "10",
          filtro: filtro,
          idGrupo: idGrupo,
          tipo: tipo,
        },
      })
      .pipe(
        map((data) => {
          let pag = {
            currentPage: data.headers.get("X-Pagination-Current-Page"),
            pageCount: data.headers.get("X-Pagination-Page-Count"),
            perPage: data.headers.get("X-Pagination-Per-Page"),
            totalCount: data.headers.get("X-Pagination-Total-Count"),
          };
          return {
            nome: data.body,
            pagination: pag,
          };
        })
      );
  }

  getMigraParticipante(idGrupo: any, idParticipante: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/get-migra-participante", {
        params: { idGrupo: idGrupo, idParticipante: idParticipante },
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  removerParticipanteGrupo(idGrupo: any, idParticipante: any, idGrupoNovo: any, tipo: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/remover-participante-grupo", {
        params: {
          id: idGrupo,
          idPessoa: idParticipante,
          idNovo: idGrupoNovo,
          tipo: tipo,
        },
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getValidaRegra(idGrupo: any, idParticipante: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/get-valida-regra", {
        params: { idGrupo: idGrupo, idParticipante: idParticipante },
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getGruposPessoa(idPessoa: any, tipo: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/get-grupos-pessoa", {
        params: { idPessoa: idPessoa, tipo: tipo },
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getFotoReuniao(entidade: any, idReuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/get-fotos", {
        entidade: entidade,
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  downloadPauta(idReuniao: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/download-pauta", {
        params: {
          idReuniao: idReuniao,
        },
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  removerImagem(id: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/remover-foto", {
        id: id,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getEsporadicos(idReuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/get-esporadicos", {
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getOvelinhas() {
    return this.http.post<any>(this.baseUrl + "/grupo/reuniao-ovelinhas", {}).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getOvelinhasHistorico(idPessoa: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/reuniao-ovelinhas-historico", {
        idPessoa: idPessoa,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  checkIsMenorIdade(idPessoa: any) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/check-is-menor-idade", {
        params: { idPessoa: idPessoa },
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  check(
    idPessoa: any,
    entidade: any,
    idEntidade: any,
    observacao: any,
    idResponsavel: any,
    isCheckin: any,
    idReuniao: any
  ) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/realizar-check", {
        idPessoa: idPessoa,
        entidade: entidade,
        idEntidade: idEntidade,
        observacao: observacao,
        idResponsavel: idResponsavel,
        isCheckin: isCheckin,
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getFamiliaresPresencaReuniao(idReuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/get-familiares-presenca-reuniao", {
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  salvarPresencaOvelinhas(familiares: any, idReuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/salvar-presenca-ovelinhas", {
        familiares: familiares,
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  checkBarcode(idPessoa: any, idReuniao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/check-barcode", {
        idPessoa: idPessoa,
        idReuniao: idReuniao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  salvarStatus(idReuniao: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/salvar-status", { idReuniao }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getGruposGeral(filtro: any, tipoGrupo: any, regiao: any, dia: any, tipo: any, pag: { currentPage: any }) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/get-grupos-geral", {
        observe: "response",
        params: {
          page: pag.currentPage,
          "per-page": "10",
          filtro: filtro,
          tipoGrupo: tipoGrupo,
          regiao: regiao,
          dia: dia,
          tipo: tipo,
        },
      })
      .pipe(
        map((data) => {
          let pag = {
            currentPage: data.headers.get("X-Pagination-Current-Page"),
            pageCount: data.headers.get("X-Pagination-Page-Count"),
            perPage: data.headers.get("X-Pagination-Per-Page"),
            totalCount: data.headers.get("X-Pagination-Total-Count"),
          };
          return {
            grupos: data.body,
            pagination: pag,
          };
        })
      );
  }

  getParticipantesGeral(
    filtro: { q: any; pessoa: any; isResponsavel: any },
    pag: { currentPage: any },
    idReuniao: any
  ) {
    return this.http
      .get<any>(this.baseUrl + "/grupo/get-participantes-geral", {
        observe: "response",
        params: {
          page: pag.currentPage,
          "per-page": "10",
          filtro: filtro.q,
          pessoa: filtro.pessoa,
          isResponsavel: filtro.isResponsavel,
          idReuniao: idReuniao,
        },
      })
      .pipe(
        map((data) => {
          let pag = {
            currentPage: data.headers.get("X-Pagination-Current-Page"),
            pageCount: data.headers.get("X-Pagination-Page-Count"),
            perPage: data.headers.get("X-Pagination-Per-Page"),
            totalCount: data.headers.get("X-Pagination-Total-Count"),
          };

          return {
            pessoas: data.body,
            pagination: pag,
          };
        })
      );
  }

  updateFoto(base64: any, idReuniao: any, entidade: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/upload-foto", {
        foto: base64,
        idReuniao: idReuniao,
        entidade: entidade,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getGrupos(filtro: {}, tipo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/get-grupos", {
        filtro: filtro,
        tipo: tipo,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getGruposRede(idNodePai = "#", tipo = "", grupoMinisterio = "") {
    return this.http
      .post<any>(this.baseUrl + "/hierarquia/node-funcao", {
        nodeId: idNodePai,
        tipo: tipo,
        grupoMinisterio: grupoMinisterio,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getTiposReuniao() {
    return this.http.get<any>(this.baseUrl + "/grupo/get-tipos-reuniao").pipe(
      map((data) => {
        return data;
      })
    );
  }

  getGruposTipos(tipo: any, filtroTipos: number | null) {
    return this.http.post<any>(this.baseUrl + "/grupo/grupo-tipos", { tipo: tipo, filtroTipos: filtroTipos }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getGrupoHierarquia() {
    return this.http.get<any>(this.baseUrl + "/grupo/get-grupo-hierarquia").pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getGrupoCiclos() {
    return this.http.get<any>(this.baseUrl + "/grupo/get-grupo-ciclo").pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  salvarGrupo(grupo: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/salvar-grupo", grupo).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  buscarGrupo(id: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/buscar-grupo", { id: id }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  buscarGrupoEndereco(id: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/buscar-grupo-endereco", { id: id }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  alterarEnderecoGrupoPessoa(idGrupo: any, idPessoa: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/salvar-endereco-grupo-pessoa", {
        idGrupo: idGrupo,
        idPessoa: idPessoa,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getGruposRegiao() {
    return this.http.post<any>(this.baseUrl + "/grupo/grupo-regiao", {}).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getGrupoDetalhes(idGrupo: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/grupo/" + idGrupo).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  confirmarPresenca(presenca: any, idGrupo: any, idProjeto: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/confirmar-presenca", {
        presenca: presenca,
        idGrupo: idGrupo,
        idProjeto: idProjeto,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getParticipantes(idReuniao: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/reuniao/" + idReuniao + "/membros").pipe(
      map((data) => {
        if (!data.error) {
          return data.pessoas;
        } else {
          return false;
        }
      })
    );
  }

  getVisitantes(idReuniao: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/reuniao/" + idReuniao + "/visitantes").pipe(
      map((data) => {
        if (!data.error) {
          return data.pessoas;
        } else {
          return false;
        }
      })
    );
  }

  getReuniao(idReuniao: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/reuniao/" + idReuniao).pipe(
      map((data) => {
        if (!data.error) {
          return data.reuniao;
        } else {
          return false;
        }
      })
    );
  }

  getReunioes(idGrupo: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/grupo/" + idGrupo + "/reunioes").pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  salvarReuniao(reuniao: any, idReuniao: string) {
    return this.http.post<any>(this.baseAntigaUrl + "/reuniao/" + idReuniao + "/resumo", reuniao).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  GrupoGeo(latitude: any, longitude: any, filtro: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/grupo-geo", {
        latitude: latitude,
        longitude: longitude,
        filtro: filtro,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  enviarSolicitacao(idPessoa: any, idGrupo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/enviar-solicitacao", {
        idUsuario: idPessoa,
        idGrupo: idGrupo,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  criarReuniao(reuniao: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/salvar-reuniao", reuniao).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  salvarParticipantes(dados: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/presencas", dados).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  salvarParticipante(dados: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/presenca", dados).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  removerParticipante(idGrupo: string, idParticipante: string) {
    return this.http.delete<any>(this.baseUrl + "/grupo/" + idGrupo + "/participante/" + idParticipante).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  removerVisitante(idGrupo: string, idVisitante: string) {
    return this.http.delete<any>(this.baseUrl + "/grupo/" + idGrupo + "/visitante/" + idVisitante).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  removerEsporadico(idEsporadico: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/remover-esporadico", {
        idEsporadico: idEsporadico,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getGrupoCargo() {
    return this.http.get<any>(this.baseUrl + "/grupo-cargo").pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getGrupoCargoNovo(tipo: any) {
    return this.http.post<any>(this.baseUrl + "/grupo-cargo/get-by-tipo", { tipo: tipo }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getMensagem(idMensagem: string, idGrupo: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/grupo/" + idGrupo + "/mensagem/" + idMensagem).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  criarParticipante(idGrupo: string, participante: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/" + idGrupo + "/participante-regra", participante).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  checkGrupo(idPessoa: any, idGrupo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/check-pessoa", {
        idPessoa: idPessoa,
        idGrupo: idGrupo,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getParticipantesGrupo(idGrupo: string) {
    return this.http.get<any>(this.baseAntigaUrl + "/grupo/" + idGrupo + "/participantes").pipe(
      map((data) => {
        if (!data.error) {
          return data.participantes;
        } else {
          return false;
        }
      })
    );
  }

  criarVisitante(idGrupo: string, visitante: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/" + idGrupo + "/visitante-regra", visitante).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  criarEsporadico(idReuniao: any, visitante: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/salvar-esporadico", {
        idReuniao: idReuniao,
        idEsporadico: visitante,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getVisitantesGrupo(idGrupo: string) {
    return this.http.get<any>(this.baseUrl + "/grupo/" + idGrupo + "/visitante").pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  saveVisitanteGrupo(idGrupo: string, pessoa: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/" + idGrupo + "/pessoa", pessoa).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getPauta(idReuniao: any) {
    return this.http.post<any>(this.baseUrl + "/grupo-reuniao/pauta", { id: idReuniao }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  grupoGrafico(idGrupo: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/grupo-grafico", { idGrupo: idGrupo }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  savePauta(idReuniao: any, pauta: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo-reuniao/pauta", {
        id: idReuniao,
        pauta: pauta,
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getGrupoCaixa(idGrupo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo-caixa/get-grupo-caixa", {
        idGrupo: idGrupo,
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getLancamentos(id: string | number | boolean, pag: { currentPage: string | number | boolean }) {
    let params = new HttpParams()
      .set("expand", "grupoCaixaItem,pessoaVinculo,lancamentoOfertas")
      .set("page", pag.currentPage)
      .set("per-page", "10")
      .set("id", id);

    return this.http
      .get<any>(this.baseUrl + "/grupo-caixa/get-grupo-caixa-lancamento", {
        observe: "response",
        params: params,
      })
      .pipe(
        map((data) => {
          let pag = {
            currentPage: data.headers.get("X-Pagination-Current-Page"),
            pageCount: data.headers.get("X-Pagination-Page-Count"),
            perPage: data.headers.get("X-Pagination-Per-Page"),
          };
          return {
            lancamentos: data.body,
            pagination: pag,
          };
        })
      );
  }

  getItensCaixa(tipo: any, idGrupo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo-caixa/get-itens-caixa", {
        tipo: tipo,
        idGrupo: idGrupo,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  salvarCaixaTransferencia(lancamento: {
    valor: { replace: (arg0: RegExp, arg1: string) => number };
    item: any;
    idGrupoCaixa: any;
    idPessoa: any;
    data: any;
  }) {
    return this.http
      .post<any>(this.baseUrl + "/grupo-caixa/salvar-transferencia", {
        isTransferencia: "1",
        valor: lancamento.valor.replace(/\D+/g, "") * -1,
        idGrupoCaixaItem: lancamento.item,
        idGrupoCaixa: lancamento.idGrupoCaixa,
        idPessoaVinculo: lancamento.idPessoa,
        dataLancamento: lancamento.data,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  salvarCaixaLancamento(
    tipo: string,
    lancamento: {
      valor: { replace: (arg0: RegExp, arg1: string) => number };
      item: any;
      idGrupoCaixa: any;
      idPessoa: any;
      data: any;
      descricao: any;
    }
  ) {
    return this.http
      .post<any>(this.baseUrl + "/grupo-caixa/salvar-lancamento", {
        valor: tipo == "S" ? lancamento.valor.replace(/\D+/g, "") * -1 : lancamento.valor.replace(/\D+/g, ""),
        idGrupoCaixaItem: lancamento.item,
        idGrupoCaixa: lancamento.idGrupoCaixa,
        idPessoaVinculo: lancamento.idPessoa,
        dataLancamento: lancamento.data,
        descricao: lancamento.descricao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  removerLancamento(idLancamento: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo-caixa/remover-lancamento", {
        idLancamento: idLancamento,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  salvarEndereco(endereco: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/endereco", endereco).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  salvarEnderecoGoogle(idEndereco: any, enderecoCompleto: any, idPais: any, objEndereco: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/endereco-google", {
        idEndereco: idEndereco,
        formatado: enderecoCompleto,
        idPais: idPais,
        objEndereco: objEndereco,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  getGrupoHorario(id: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/buscar-grupo-horario", { id: id }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  removerHorario(id: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/remover-horario", { id: id }).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  salvarHorario(horario: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/salvar-horario", horario).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  getHierarquia(idGrupo: any, tipo: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/get-estrutura", {
        idGrupo: idGrupo,
        tipoRaiz: tipo,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  removerHierarquia(idHierarquiaGrupoFuncao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/remover-estrutura", {
        idHierarquiaGrupoFuncao: idHierarquiaGrupoFuncao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  salvarHierarquia(arrHierarquiaGrupoFuncao: any, idGrupo: any, idHierarquiaFuncao: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/salvar-estrutura", {
        arrHierarquiaGrupoFuncao: arrHierarquiaGrupoFuncao,
        idGrupo: idGrupo,
        idHierarquiaFuncao: idHierarquiaFuncao,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  criarFeedback(feedback: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/criar-feedback", feedback).pipe(
      map((data) => {
        return !data.error ? data : false;
      })
    );
  }

  gerenciarSolicitacoes(idGrupo: any, filtro: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/gerenciar-solicitacoes", {
        idGrupo,
        filtro,
      })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  atualizarStatus(idSolicitacao: any, anotacao = null) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/atualizar-status", { idSolicitacao: idSolicitacao, anotacao: anotacao })
      .pipe(
        map((data) => {
          return !data.error ? data : false;
        })
      );
  }

  postReunioes(idGrupo: any, filtro: any, pagination: any) {
    return this.http
      .post<any>(this.baseUrl + "/grupo/post-reunioes", { idGrupo, filtro, pagination }, { observe: "response" })
      .pipe(
        map((response) => {
          return response.body;
        })
      );
  }

  excluirReuniao(idReuniao: any) {
    return this.http.post<any>(this.baseUrl + "/grupo/apagar-reuniao", {idReuniao})
    .pipe(
      map((data) => {
        if(!data.error) {
          return data;
        } else {
          return false
        }
      })
    );
  }

  getGruposReunioesList() {
    return this.http
      .get<Meeting[]>(this.baseUrl + "/grupo/get-grupos-reunioes-list")
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
}
